import { render, staticRenderFns } from "./ListarRegrasPagamento.vue?vue&type=template&id=2447c6f6&"
import script from "./ListarRegrasPagamento.vue?vue&type=script&lang=js&"
export * from "./ListarRegrasPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports